var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFortnoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 118.7 24.7",
    style: {
      enableBackground: "new 0 0 118.7 24.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003824;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1,0.9H7.8c-4.3,0-7.2,3-7.2,7.3v15.4c0,0.5,0.3,0.8,0.8,0.8h3.5c0.5,0,0.8-0.3,0.8-0.8v-6.4h8.5 c0.5,0,0.8-0.3,0.8-0.8v-3.2c0-0.5-0.3-0.8-0.8-0.8H5.5V7.9c0-1.4,0.9-2.4,2.4-2.4h6.3c0.5,0,0.8-0.3,0.8-0.8v-3 C14.8,1.2,14.5,0.9,14.1,0.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,5c-5.6,0-9.8,4.3-9.8,9.8s4.1,9.8,9.8,9.8s9.8-4.3,9.8-9.8S31.6,5,26,5z M26,20.1c-2.9,0-5-2.1-5-5.2 s2.1-5.2,5-5.2s5,2.1,5,5.2S28.9,20.1,26,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.1,5.4h-5.8V0.9c0-0.5-0.3-0.8-0.8-0.8H49c-0.5,0-0.8,0.3-0.8,0.8v4.4h-4.1c-4.3,0-7.2,2.9-7.2,7.2v11 c0,0.5,0.3,0.8,0.8,0.8h3.5c0.5,0,0.8-0.3,0.8-0.8v-11c0-1.4,0.9-2.4,2.4-2.4h4.1v7c0,4.3,2.9,7.2,7.2,7.2h3.5 c0.5,0,0.8-0.3,0.8-0.8v-3.4c0-0.5-0.3-0.8-0.8-0.8h-3.5c-1.4,0-2.4-0.9-2.4-2.4V10h5.8c0.5,0,0.8-0.3,0.8-0.8V6 C59.7,5.6,59.5,5.4,59.1,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.7,5c-5.2,0-8.5,3.4-8.5,8.4v10.1c0,0.5,0.3,0.8,0.8,0.8h3.5c0.5,0,0.8-0.3,0.8-0.8v-9.9 c0-2.3,1.5-3.8,3.8-3.8s3.8,1.4,3.8,3.8v10.1c0,0.5,0.3,0.8,0.8,0.8h3.5c0.5,0,0.8-0.3,0.8-0.8V13.5C78.3,8.3,74.9,5,69.7,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.4,5c-5.6,0-9.8,4.3-9.8,9.8s4.1,9.8,9.8,9.8s9.8-4.3,9.8-9.8S95,5,89.4,5z M89.4,20.1c-2.9,0-5-2.1-5-5.2 s2.1-5.2,5-5.2s5,2.1,5,5.2S92.3,20.1,89.4,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.1,14.7l6.1-6.1c0.3-0.3,0.3-0.6,0-0.9l-2.4-2.4c-0.3-0.3-0.6-0.3-0.9,0l-6.1,6.1l-6.1-6.1 c-0.3-0.3-0.6-0.3-0.9,0l-2.4,2.4C99,8,99,8.3,99.3,8.6l6.1,6.1l-6.1,6.1c-0.3,0.3-0.3,0.6,0,0.9l2.4,2.4c0.3,0.3,0.6,0.3,0.9,0 l6.1-6.1l6.1,6.1c0.3,0.3,0.6,0.3,0.9,0l2.4-2.4c0.3-0.3,0.3-0.6,0-0.9L112.1,14.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortnoxLogo);
export default __webpack_public_path__ + "static/media/fortnox-logo.5074aebe4f29e79cce83eb87406a4ff9.svg";
export { ForwardRef as ReactComponent };